import { setBdcDemandModelApi, getBdcInvoiceParamsApi } from 'components/pages/wall/bdcWinsDemand/BdcDemandModel';
import axiosInstance from 'config/axiosConfig';
import { GET_WINS_COMPANY_ENDPOINT,
  SET_WINS_COMPANY_ENDPOINT,
  UPDATE_WINS_COMPANY_ENDPOINT,
  SET_BDC_DEMAND_HISTORY_ENDPOINT,
  UPDATE_BDC_DEMAND_HISTORY_ENDPOINT,
  GET_BDC_DEMAND_HISTORY_ENDPOINT,
  GET_BDC_DETAILS_ENDPOINT,
  GET_INVOICE_DETAILS_ENDPOINT, 
  GET_ALL_EXPIRED_WINS_COMPANY_ENDPOINT,
  GET_BDC_CONFIG_ENDPOINT,
  GET_BDC_COMPANIES_ENDPOINT,
  INTERNAL_BDC_ACCOUNT_ENDPOINT,
  CONFIRM_INTERNAL_BDC_PAYMENT_ENDPOINT
} from 'constants/api';
// import { BdcDemandModelApi, companyModelApi, setBdcDemandModelApi, getBdcInvoiceParamsApi } from './BdcDemandModel';

class BdcDemandApi {
  async getInternalBdcAccount(): Promise<{ data: InternalBdcAccount | null }> {
    const { data } = await axiosInstance().get(INTERNAL_BDC_ACCOUNT_ENDPOINT);
    return data;
  }

  async saveInternalBdcAccount(body: InternalBdcAccount): Promise<{ data: InternalBdcAccount }> {
    const { data } = await axiosInstance().put(INTERNAL_BDC_ACCOUNT_ENDPOINT, body);
    return data;
  }

  async getBdcConfig(): Promise<{ data: { provider: 'cynov' | 'internal'; erpReady: boolean | null; internalReady: boolean } }> {
    const { data } = await axiosInstance().get(GET_BDC_CONFIG_ENDPOINT);
    return data;
  }

  async getBdcCompanies(): Promise<{ data: Array<{ companyId: number; companyName: string; superAdminFirstName: string; superAdminLastName: string; superAdminEmail: string; superPlatforms: Array<{ id: number; name: string }>; erpReady: boolean; walletWins: number }> }> {
    const { data } = await axiosInstance().get(GET_BDC_COMPANIES_ENDPOINT);
    return data;
  }

  async confirmInternalPayment(body: { bdcId: string; paymentReference: string; paymentDate: string; amount: number; invoiceId?: string; invoicePdf?: string }) {
    const { data } = await axiosInstance().post(CONFIRM_INTERNAL_BDC_PAYMENT_ENDPOINT, body);
    return data;
  }
  async getWinsCompany(programId, userUuid) {
    const { data } = await axiosInstance().get(GET_WINS_COMPANY_ENDPOINT, { 
      params:{
        programId,
        userUuid 
      }
  });

    return data;
  }
  
  async setWinsCompany(body) {
    const { data } = await axiosInstance().post(SET_WINS_COMPANY_ENDPOINT, body);
    
    return data;
    }
    
  async updateWinsCompany(body) {
    const { data } = await axiosInstance().post(UPDATE_WINS_COMPANY_ENDPOINT, body);
    
    return data;
  }
  
  async setBdcDemandHisory(body: setBdcDemandModelApi) {
    const payload = JSON.stringify(body);
    const data = await axiosInstance().post(SET_BDC_DEMAND_HISTORY_ENDPOINT, payload);
    return data;
  }

  async updateBdcDemandHisory(body: setBdcDemandModelApi) {
    const { data } = await axiosInstance().post(UPDATE_BDC_DEMAND_HISTORY_ENDPOINT, body);

    return data;
  }

  async getBdcDemandHistory(params?: getBdcInvoiceParamsApi) {
    const { data } = await axiosInstance().get(GET_BDC_DEMAND_HISTORY_ENDPOINT, {
      params:params
    });
    return data;
  }
  
  async getBdcDetails(params: getBdcInvoiceParamsApi) {
    const { data } = await axiosInstance().get(GET_BDC_DETAILS_ENDPOINT, {
      params:{
        bdcId: params.bdcId,
        invoiceId: params.invoiceId,
        userAdminUuId: params.userAdminUuId
      }
    });
    return data;
  }

  async getInvoiceDetails(params: getBdcInvoiceParamsApi) {
    const { data } = await axiosInstance().get(GET_INVOICE_DETAILS_ENDPOINT, {
      params:{
        bdcId: params.bdcId,
        invoiceId: params.invoiceId,
        userAdminUuId: params.userAdminUuId
      }
    });

    return data;
  }

  async getAllExpiredWins(userUuid, platformId, programId) {
    const { data } = await axiosInstance().get(GET_ALL_EXPIRED_WINS_COMPANY_ENDPOINT, { 
      params:{
        userUuid : userUuid,
        platformId: platformId,
        programId: programId,
      }
  });
  
    return data;
  }
}
      
export default BdcDemandApi;

export type InternalBdcAccount = {
  issuerName: string;
  issuerAddress: string;
  issuerSiret: string;
  issuerVatNumber: string;
  vatRate: number;
  paymentBeneficiary: string;
  paymentIban: string;
  paymentBic: string;
  updatedBy?: string;
  updatedAt?: string;
};
